import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { User } from "../../users/_types/user";

export class Group extends Resource {
    public override type = 'groups';

    @prop()
    @required()
    public name!: string;

    @prop()
    @required()
    public responsibleUserId!: string;
    public responsibleUser!: User;

}